import React from 'react';
import { DICE_BOX_FAILURE_WEBGL } from '../../../utils/diceBoxManager';

/**
 * Warning shown when the 3D dice roller can't run. WebGL turned off is permanent until the browser changes, so it
 * says how to turn hardware acceleration on; other failures retry on their own.
 */
export default function DiceBoxWarning({ reason }) {
  if (reason === DICE_BOX_FAILURE_WEBGL) {
    return (
      <div className="zombies-character-sheet__dice-warning" role="alert">
        3D dice need WebGL, which is turned off in this browser. Rolls use plain numbers instead.
        To turn it on, enable hardware acceleration: in Firefox, Settings → General → Performance
        (“Use hardware acceleration when available”); in Chrome or Edge, Settings → System
        (“Use graphics acceleration when available”). Then restart the browser.
      </div>
    );
  }
  return (
    <div className="zombies-character-sheet__dice-warning" role="alert">
      The 3D dice roller failed to load. Rolls will use fallback values until it
      reconnects.
    </div>
  );
}
